import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

function Stars() {
  const starsRef = useRef([]);

  useEffect(() => {
    if (starsRef.current.length > 0) {
      gsap.to(starsRef.current, {
        opacity: 0.1,
        duration: 1,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        stagger: {
          each: 0.1,
          from: "random"
        }
      });
    }
  }, []);

  const stars = new Array(50).fill(0).map((_, idx) => {
    const top = Math.random() * 100;
    const left = Math.random() * 100;
    const size = Math.random() * 2 + 1;
    return (
      <div
        key={idx}
        ref={(el) => (starsRef.current[idx] = el)}
        className="absolute bg-white rounded-full"
        style={{
          top: `${top}vh`,
          left: `${left}vw`,
          width: `${size}px`,
          height: `${size}px`,
          opacity: 0.8,
        }}
      />
    );
  });

  return <>{stars}</>;
}

export default Stars;
